import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=d0ea58f8&scoped=true&"
var script = {}
import style0 from "./Copyright.vue?vue&type=style&index=0&id=d0ea58f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ea58f8",
  null
  
)

export default component.exports